import React from 'react'
import { KibChewyIcon } from '@chewy/kib-icons-react'

import { PrescriptionType } from '~/constants/prescription'
import i18nPortal from '~/locales/i18n'

import styles from './PrescriptionWorkflowCell.module.scss'

const WorkflowTypeMap = {
  [PrescriptionType.CHEWY]: (
    <div className={styles.chewyCell}>
      <KibChewyIcon className={styles.chewyIcon} data-testid="chewy-icon" />
    </div>
  ),
  [PrescriptionType.IN_HOUSE]: i18nPortal.t(
    'Soap:PRESCRIPTIONS_WIDGET.WORKFLOW_TYPES.IN_HOUSE',
  ),
  [PrescriptionType.SCRIPT_OUT]: i18nPortal.t(
    'Soap:PRESCRIPTIONS_WIDGET.WORKFLOW_TYPES.OUTSIDE_PHARMACY',
  ),
}

const PrescriptionWorkflowCell = ({
  workflowType,
}: {
  workflowType: PrescriptionType
}) => {
  const workflowDisplay = WorkflowTypeMap[workflowType] || ''

  return <>{workflowDisplay}</>
}

export default PrescriptionWorkflowCell
